<template>
  <!--合同级别--->
  <el-select v-model="contractLevelCode" clearable>
    <el-option
      v-for="item in contractLevelList"
      :key="item.dictCode"
      :label="item.dictName"
      :value="item.dictCode">
    </el-option>
  </el-select>
  <!------------->
</template>

<script>
  import {getListByTypeCodeAndPCode} from '@/api/dict/dic_manage'

  export default {
    name: "select-contractLevel",
    data() {
      return {
        contractLevelList: [],
        contractLevelCode: ''
      }
    },
    created() {
      let data = {
        dictTypeCode: 'CONTRACT_LEVEL',
        parentCode: -1,
      }
      getListByTypeCodeAndPCode(data).then(res => {
        if (res.code == 1) {
          this.contractLevelList = res.data
        }
      })
    },
    watch: {
      contractLevelCode: function (currentVal) {
        this.$emit('contractLevelInfo', {contractLevelCode: currentVal})
      }
    }
  }
</script>

<style scoped>

</style>
